module.exports = __webpack_public_path__ + "img/logo.057c5eda.png";